import work from './api/work'
import page from './api/page'

export default {
  state: {},
  mutations: {},
  actions: {},
  getters: {},
  modules: {
    work,
    page
  }
}